import { Box } from "@mui/material"
import Alert from "@mui/material/Alert"
import Badge from "@mui/material/Badge"
import type { SnackbarCloseReason, SnackbarOrigin } from "@mui/material/Snackbar"
import Snackbar from "@mui/material/Snackbar"
import type { FC } from "react"

import type { Notification } from "@/schemas/notification"

type NotificationTemplateProps = Notification & {
  open: boolean
  unreadCount: number
  handleSnackbarClose: (event: React.SyntheticEvent<any> | Event, reason: SnackbarCloseReason) => void
  handleExited: () => void
  anchorOrigin: SnackbarOrigin
}

export const NotificationTemplate: FC<NotificationTemplateProps> = ({
  id,
  open,
  handleSnackbarClose,
  handleExited,
  type,
  silent,
  message,
  icon: MuiIcon,
  unreadCount,
  anchorOrigin,
  autoHideDuration,
  content,
}) => {
  if (silent) return null

  return (
    <Snackbar
      key={id}
      open={open}
      onClose={handleSnackbarClose}
      TransitionProps={{ onExited: handleExited }}
      anchorOrigin={anchorOrigin}
      role='alert'
      autoHideDuration={autoHideDuration}
      aria-description={`Global Notification. ${message}`}
      className='w-1/4 max-w-[75%] text-wrap'
    >
      <Box className='relative w-full text-wrap'>
        {unreadCount > 0 && <Badge badgeContent={unreadCount} color='error' className='absolute right-1 top-1' />}
        <Alert
          variant='filled'
          severity={type}
          onClose={handleSnackbarClose}
          icon={MuiIcon && <MuiIcon />}
          sx={{ width: "100%", padding: "0.75rem 1rem" }}
        >
          {content || message}
        </Alert>
      </Box>
    </Snackbar>
  )
}
